import { HStack, Switch, Text, VStack } from '@chakra-ui/react';
import { useProfile } from '../contexts/ProfileProvider';

function NotificationToggle({
  name,
  onChange,
  value,
  isLoading,
}: {
  name: string;
  onChange: () => void;
  value: boolean;
  isLoading: boolean;
}) {
  return (
    <HStack>
      <Switch disabled={isLoading} size={'md'} isChecked={value} onChange={onChange} />
      <Text>{name}</Text>
    </HStack>
  );
}

export function NotificationsForm() {
  const { profile, updateProfile, isLoading } = useProfile();
  return (
    <VStack w={'100%'} align={'flex-start'} spacing={5}>
      <Text fontSize={'14px'}>Altere regras de notificação e outras configurações extras.</Text>
      <NotificationToggle
        isLoading={isLoading}
        name="Push Notification"
        value={profile?.allowedPushNotifications || false}
        onChange={() => {
          updateProfile({ allowed_push_notifications: !profile?.allowedPushNotifications });
        }}
      />
      <NotificationToggle
        isLoading={isLoading}
        name="Emails"
        value={profile?.allowedPromotionalEmails || false}
        onChange={() => {
          updateProfile({ allowed_promotional_emails: !profile?.allowedPromotionalEmails });
        }}
      />
      <NotificationToggle
        isLoading={isLoading}
        name="WhatsApp"
        value={profile?.allowedWhatsapp || false}
        onChange={() => {
          updateProfile({ allowed_whatsapp: !profile?.allowedWhatsapp });
        }}
      />
    </VStack>
  );
}
